import airway from "./airway"

export default {
    airway
}